import React from 'react';
import { COLOR_SOLID_MAP, COLOR_CMY, COLOR_CMYK } from './ColorBar';

/**
 * Rettangolo descrittivo del colore per la card "Colore" nel dettaglio prodotto.
 * Riusa la stessa mappatura colori di `ColorBar` (barra sull'immagine prodotto).
 * Per Tricromia/Colori (CMY) e Quadricromia (CMYK) mostra un rettangolo diviso
 * in spicchi colorati invece di un colore pieno.
 */
interface Props {
  color?: string | null;
  width?: number;
  height?: number;
}

export function ColorDot({ color, width = 28, height = 16 }: Props) {
  if (!color || color === '-') return null;
  const lower = color.toLowerCase();
  const isTri  = lower === 'tricromia' || lower === 'colori';
  const isQuad = lower === 'quadricromia';
  const solid  = COLOR_SOLID_MAP[lower];

  if (!isTri && !isQuad && !solid) return null;

  // Tricromia/Quadricromia → rettangolo diviso in spicchi colorati
  if (isTri || isQuad) {
    const colors = isQuad ? COLOR_CMYK : COLOR_CMY;
    return (
      <span
        className="inline-flex rounded-[3px] overflow-hidden border border-black/15 flex-shrink-0"
        style={{ width, height }}
        data-testid="product-color-dot-multi"
        aria-hidden
      >
        {colors.map((c, i) => (
          <span key={i} className="h-full flex-1" style={{ backgroundColor: c }} />
        ))}
      </span>
    );
  }

  // Colore singolo → pallino pieno
  return (
    <span
      className="inline-block rounded-full border border-black/15 flex-shrink-0"
      style={{ width: height, height, backgroundColor: solid }}
      data-testid="product-color-dot"
      aria-hidden
    />
  );
}
